export default "__VITE_ASSET__D5qud3tj__"